import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d57f9546-ec2f-472e-a064-f2c1e178a876", content: "Sampling", options: {} },
  { id: "74526cbc-2c1b-4f0d-b345-4b2235d1b29d", content: "Zero padding", options: {} },
  { id: "3d3d7896-6139-4269-b05d-ede9dc48259d", content: "Windowing", options: {} },
  { id: "87bc6028-d7ae-4da6-aa4c-1338a5ad6694", content: "Low-pass signal", options: {} },
];

const groups = [
  { id: "7b17d30a-523e-423a-8f7e-a7724f12ae12", content: "Periodisation of the spectrum", options: {} },
  { id: "a9b617f8-6897-43c1-b12f-6d5291df99d8", content: "Increase of the frequency precision", options: {} },
  { id: "6faef250-9e29-42bf-a592-c4de95308d97", content: "Ripples", options: {} },
  { id: "eb064c66-4c53-403a-9789-befe90586a10", content: "Shannon criteria", options: {} },
];

export const task: Task = {
  id: "81459196-8148-4fa7-88f9-ed42cc7a5abd",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "7b17d30a-523e-423a-8f7e-a7724f12ae12", itemsId: ["d57f9546-ec2f-472e-a064-f2c1e178a876"] },
    { groupId: "a9b617f8-6897-43c1-b12f-6d5291df99d8", itemsId: ["74526cbc-2c1b-4f0d-b345-4b2235d1b29d"] },
    { groupId: "6faef250-9e29-42bf-a592-c4de95308d97", itemsId: ["3d3d7896-6139-4269-b05d-ede9dc48259d"] },
    { groupId: "eb064c66-4c53-403a-9789-befe90586a10", itemsId: ["87bc6028-d7ae-4da6-aa4c-1338a5ad6694"] },
  ],
};
